import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube } from "react-icons/fa";

export default function ProcurementServicesFooter() {
  return (
    <footer className="ps-footer">
      <div className="ps-footer__inner">
        <div className="ps-footer__brand">
          <Link to="/home" className="ps-footer__logo">
            <span className="ps-footer__logo-mark" aria-hidden />
            TROCANET
          </Link>
          <p>
            AI-powered procurement services for modern businesses — discover suppliers, compare
            quotes, and manage sourcing with confidence.
          </p>
          <div className="ps-footer__social" aria-label="Social links">
            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn aria-hidden />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
              <FaFacebookF aria-hidden />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
              <FaTwitter aria-hidden />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
              <FaYoutube aria-hidden />
            </a>
          </div>
        </div>

        <div className="ps-footer__col">
          <h4>Services</h4>
          <Link to="/procurement-services/supplier-discovery">Supplier Discovery</Link>
          <Link to="/procurement-services/managed-procurement">Managed Procurement</Link>
          <Link to="/procurement-services/procurement-retainer">Procurement Retainer</Link>
          <Link to="/logistics-providers">Logistics</Link>
        </div>

        <div className="ps-footer__col">
          <h4>Company</h4>
          <Link to="/about">About Us</Link>
          <Link to="/partner-with-us">Partner with Us</Link>
          <Link to="/investor-relations" className="ps-footer__link--hidden">
            Investor Relations
          </Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="ps-footer__col">
          <h4>Resources</h4>
          <Link to="/help-center">Help Center</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/case-studies">Case Studies</Link>
        </div>

        <div className="ps-footer__col">
          <h4>Support</h4>
          <Link to="/help-center">Help Center</Link>
          <Link to="/submit-dispute">Submit a Dispute</Link>
          <Link to="/feedback">Feedback</Link>
          <Link to="/refund-cancellation-policy">Refund &amp; Cancellation Policy</Link>
        </div>

        <div className="ps-footer__newsletter">
          <h4>Stay Connected</h4>
          <p>Get procurement insights and platform updates.</p>
          <form
            className="ps-footer__newsletter-form"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <input type="email" placeholder="Enter your email" aria-label="Email address" />
            <button type="submit" aria-label="Subscribe">
              →
            </button>
          </form>
        </div>
      </div>

      <div className="ps-footer__bar">
        <span>© {new Date().getFullYear()} Trocanet. All rights reserved.</span>
        <span className="ps-footer__badges">
          Global Presence | Secure | ISO 27001 Certified
        </span>
      </div>
    </footer>
  );
}
